// Scroll reveal
  const bdObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
        if (entry.target.closest('.bd-stats-bar')) bdAnimateCounters(entry.target.closest('.bd-stats-bar'));
      }
    });
  }, { threshold: 0.12 });
  document.querySelectorAll('.reveal, .reveal-left, .reveal-right, .reveal-scale').forEach(el => bdObserver.observe(el));

  // Stats bar counters
  let bdCountersStarted = false;
  function bdAnimateCounters(container) {
    if (bdCountersStarted) return;
    bdCountersStarted = true;
    container.querySelectorAll('[data-target]').forEach(el => {
      const target = parseInt(el.getAttribute('data-target'));
      let current = 0;
      const step = target / 87;
      const timer = setInterval(() => {
        current += step;
        if (current >= target) { current = target; clearInterval(timer); }
        el.textContent = Math.floor(current) + (target >= 100 ? (target === 100 ? '%' : '+') : '+');
      }, 16);
    });
  }

  // Progress bar + sticky header shadow
  const bdBar = document.getElementById('bd-progress-bar');
  const bdHeader = document.getElementById('bd-site-header');
  window.addEventListener('scroll', () => {
    const scrolled = window.scrollY;
    const maxScroll = document.body.scrollHeight - window.innerHeight;
    if (bdBar) bdBar.style.width = ((scrolled / maxScroll) * 100) + '%';
    if (bdHeader) bdHeader.classList.toggle('scrolled', scrolled > 40);
  }, { passive: true });